import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    measurement: {
        outlet_id: null,
        name: null,
        equivalent_name: null,
        unit: null,
        equivalent_unit: null,
        conversion: null,
    },
    measurementList: [],
};

const getters = {
    measurement: state => state.measurement,

    measurementList: state => state.measurementList,
};

const mutations = {
    setMeasurement(state, data) {
        state.measurement = data;
    },

    resetMeasurement(state) {
        state.measurement = {
            outlet_id: null,
            name: null,
            equivalent_name: null,
            unit: null,
            equivalent_unit: null,
            conversion: null,
        };
    },

    setMeasurementList(state, data) {
        state.measurementList = data;
    },
};

const actions = {
    storeMeasurement({ commit, dispatch }, params) {
        commit('setMeasurement', params);
    },

    async showMeasurement({ commit, dispatch }, id) {
        const url = Laroute.route('franchise.inventory.measurement.show', {
            id,
        });

        startLoading(dispatch, 'show-measurement');

        try {
            const { data } = await axios.get(url);
            commit('setMeasurement', data);
            endLoading(dispatch, 'show-measurement');
            return data;
        } catch (e) {
            endLoading(dispatch, 'show-measurement');
            throw e;
        }
    },

    async createMeasurement({ commit, dispatch, state }) {
        const url = Laroute.route('franchise.inventory.measurement.create');

        startLoading(dispatch, 'save-measurement');

        try {
            await axios.post(url, state.measurement);
            endLoading(dispatch, 'save-measurement');
        } catch (e) {
            endLoading(dispatch, 'save-measurement');
            throw e;
        }
    },

    async updateMeasurement({ commit, dispatch, state }) {
        const url = Laroute.route('franchise.inventory.measurement.update');

        startLoading(dispatch, 'save-measurement');

        try {
            await axios.put(url, state.measurement);
            endLoading(dispatch, 'save-measurement');
        } catch (e) {
            endLoading(dispatch, 'save-measurement');
            throw e;
        }
    },

    async getMeasurementList({ commit, dispatch }, outlet_id) {
        const url = Laroute.route('franchise.inventory.measurement.list');

        startLoading(dispatch, 'fetch-measurements');

        const options = {
            params: {
                outlet_id,
                limit: 0,
            },
        };

        try {
            const { data } = await axios.get(url, options);
            commit('setMeasurementList', data);
            endLoading(dispatch, 'fetch-measurements');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-measurements');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/inventory-fnb/modules/measurement.js